import { getToken } from 'utils/auth';
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: "dark",
  token: getToken() || null,
  permissoes: JSON.parse(localStorage.getItem('permissoes')) || [],
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
    setLogin: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.permissoes = action.payload.permissoes; 
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('permissoes', JSON.stringify(action.payload.permissoes));
    },
    setLogout: (state) => {
      state.user = null;
      state.token = null;
      state.permissoes = [];
      localStorage.removeItem('token');
      localStorage.removeItem('permissoes');
    },
    setPermissoes: (state, action) => {
      const lista = Array.isArray(action.payload) ? action.payload : [];
      state.permissoes = lista;
      localStorage.setItem('permissoes', JSON.stringify(lista));
    },
  },
});

export const { setMode, setLogin, setLogout, setPermissoes } = globalSlice.actions;

export default globalSlice.reducer;

// ─── Action para atualizar apenas as permissoes (sem novo login) ──────────────
export const syncPermissoes = () => async (dispatch) => {
  try {
    const token = getToken();
    if (!token) return;

    const res = await fetch(`${process.env.REACT_APP_BASE_URL}/auth/minhas-permissoes`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!res.ok) return;

    const data = await res.json();
    const permissoes = Array.isArray(data.permissoes) ? data.permissoes : [];
    dispatch(globalSlice.actions.setPermissoes(permissoes));
  } catch (_) {
    // silencioso — nao quebra a UI se falhar
  }
};

